/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Kinds_BodyInputs */

const en_coaches_page_kinds_body = /** @type {(inputs: Coaches_Page_Kinds_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone who runs sessions has their calendar here. You choose who to work with and book them all the same way.`)
};

const pl_coaches_page_kinds_body = /** @type {(inputs: Coaches_Page_Kinds_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każdy, kto prowadzi wizyty, ma tu swój kalendarz. Wybierasz, z kim chcesz pracować, i rezerwujesz u każdego tak samo.`)
};

/**
* | output |
* | --- |
* | "Everyone who runs sessions has their calendar here. You choose who to work with and book them all the same way." |
*
* @param {Coaches_Page_Kinds_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_kinds_body = /** @type {((inputs?: Coaches_Page_Kinds_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Kinds_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_kinds_body(inputs)
	return en_coaches_page_kinds_body(inputs)
});